import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";

const AllApplicationRequest = () => {
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);

  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "roundName",
      ShowStatus: true,
      NmaeColumn: "دورة الجائزة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fullName",
      ShowStatus: true,
      NmaeColumn: "الاسم الكامل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },

    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: "الحقل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },

    {
      KeyName: "subjectName",
      ShowStatus: true,
      NmaeColumn: "الموضوع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "projectName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "applicationStatus",
      ShowStatus: true,
      NmaeColumn: "حالة الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "projectName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const RequestsManagerBtns = [
    // {
    //   Click: async (e) => {
    //     // setSecondarySectorsId(e.target.value);
    //     localStorage.setItem(
    //       "aI_ApplicationInformationId_Manager",
    //       e.target.value
    //     );
    //     navigate("/grants/manager/SingleTaskManager");
    //   },
    //   content: "",
    //   className: "bi bi-pencil-square",
    //   id: "editBtn",
    //   title: "عرض",
    //   ShowStatus: true,
    // },
    {
      Click: async (e) => {
        const result=JSON.parse(e.target.value)?.applicationInformationId

        console.log(result, "sssswdwdwffefssssdwdwdwdwd");
         window.open(
          `/ResearchersAward/manager/ViewApplication/ApplicationInformation/` + result,
          "_blank"
        );
        // navigate("/researcher/manager/AllTasks/" + e.target.value);
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"applicationInformationId"}
        valueButtonAction={"applicationInformationId"}
        URL={`api/Applications/GetAllAplications`}
        // UrlBody={{
        //   aI_ApplicationInformationId: localStorage.getItem(
        //     "aI_ApplicationInformationId"
        //   ),
        // }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الطلبات"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
    </>
  );
};

export default AllApplicationRequest;
